module.exports = __webpack_public_path__ + "static/media/saul-design.54af2f44.png";